import { IWarning, IWeatherWarningsState } from 'redux-state/weather-warnings/types.js';
import { IMarker } from 'types/markerCore/marker-core-type.js';
import { IMarkerV1 } from 'types/markerTypesV1/marker-v1-type.js';
import { getFirstOfArr, predicateMarkerV1 } from 'utilities/isType.js';
import { sortWarnLevel } from '../warning-severity';

export interface IMergeWarningsIntoLocationProps<T extends IMarkerV1 | IMarkerV1[] = IMarkerV1[]> {
  warnings: IWeatherWarningsState['warnings'];
  uniqueLocation: T;
  keyOverride?: string;
}

export const getMarkerWarningMeta = <T extends IMarker>(marker: T): { markerType: string; markerRegion: string } => {
  if (predicateMarkerV1(marker)) {
    const subjectItem = getFirstOfArr(marker.subject);
    if (subjectItem) {
      return { markerType: `${subjectItem.type}`, markerRegion: subjectItem.key };
    }
    return { markerType: '', markerRegion: '' };
  }
  if (marker.warnings?.type) {
    return { markerType: marker.warnings.type, markerRegion: marker.warnings.region ?? marker.key ?? '' };
  }
  return { markerType: '', markerRegion: '' };
};

export const removeDuplicateAndSortWarnings = (matchingWarnings: IWarning[]): IWarning[] => {
  const duplicate = matchingWarnings.reduce<Record<string, IWarning>>((acc, item) => {
    const key = `${item.url}${item.type}${item.key}${item.name}`;
    acc[key] = item;
    return acc;
  }, {});
  const unsortedUniqueVals = Object.values(duplicate);

  const sortedUniqueVals = sortWarnLevel({
    arr: unsortedUniqueVals,
    fn: (w) => w.warnLevel,
  });

  return sortedUniqueVals;
};
